import { intval, compare, type PhpInt } from '../../../../php-compat';
import type { PortEnv } from '../../../../port-contract';
import { array } from '../../array-path';

export interface RequiredChargeDeps {
    valid_uuid(id: unknown, caller: string): void;
    query_full_item_arr(id: unknown): unknown;
    layer_value(host: unknown, layer: string): unknown;
}
/** PHP: compute_required_item_charges (includes/functions/db/enchantment_templates/compute_required_item_charges.php:20) */
export function computeRequiredItemCharges(charged_abilities_arr: unknown, charged_spells_arr: unknown,
    env: PortEnv<RequiredChargeDeps>): PhpInt {
    let maximum: PhpInt = 0;
    for (const id of array(charged_abilities_arr).values()) {
        env.deps.valid_uuid(id, 'compute_required_item_charges:charged_ability');
        const ability = env.deps.query_full_item_arr(id);
        const value = intval(env.deps.layer_value(ability, 'ability_activation_charges') ?? 0);
        if (compare(value, maximum) > 0) maximum = value;
    }
    for (const id of array(charged_spells_arr).values()) {
        env.deps.valid_uuid(id, 'compute_required_item_charges:charged_spell');
        const spell = env.deps.query_full_item_arr(id);
        const value = intval(env.deps.layer_value(spell, 'spell_level') ?? 0);
        if (compare(value, maximum) > 0) maximum = value;
    }
    return maximum;
}
